<template>
  <el-tooltip class="item" effect="dark" content="Synchronize shuttle files" placement="top-start">
    <el-button
      id="btn-synchronize-shuttle-files"
      type="success"
      plain
      @click="handleSynchronize"
      size="mini"
    >
      Synchronize shuttle files
    </el-button>
  </el-tooltip>
</template>

<script>
import { mapActions } from 'vuex';
import { Message } from 'element-ui';
import { ADMIN_SETTINGS_SYNCHRONIZE_DOS } from '@/store/actions';
import constants from '@/utils/constants';
import accountService from '@/api/accountService';

export default {
  name: 'SynchronizeShuttleFiles',
  methods: {
    ...mapActions({
      synchronizeDOS: ADMIN_SETTINGS_SYNCHRONIZE_DOS
    }),
    handleSynchronize() {
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      accountService.syncShuttleFiles()
        .then(() => {
          this.$message.success('Shuttle files synchronized process started.');
        }).finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#btn-synchronize-shuttle-files {
  margin-left: 10px;
}
</style>
